function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  style: {
    enableBackground: "new 0 0 32 32"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 0C7.2 0 0 7.2 0 16c0 8.867 7.2 16 16 16 8.866 0 16-7.2 16-16 .066-8.8-7.134-16-16-16z",
  style: {
    fill: "#d71920"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 15.933c-2.333 4.534-2 5.934-1.6 7.134 1.067 3 6.866 2.2 12.6-2.267 5.666-4.467 8.333-10.667 5.8-13.867-2.134-2.733-7.534-2.266-12.6.8 6.333-4.066 13-4.8 15.6-1.466 2.866 3.733-.4 11.2-7.4 16.666s-15.067 6.8-18 3.134c-1.867-2.334-1.4-6.134 1.067-10H2.6l.467-1S6.4 14.4 9.8 11.333h1.333L9.467 15H12.2l-.534 1.067L9 15.933z",
  style: {
    fill: "#fff"
  }
}));
export { SvgTrend as ReactComponent };
export default "/2db3826011de9cb66bc3fdf94338cf87.svg";